export enum OriginationChannel {
  select = 0,
  retail = 1,
  brokeredOut = 2,
}
